import { AccordionDetails } from '@material-ui/core'
import React from 'react'
import FilesListFilesItem from './Item'
import { useStyles } from './Style'
import { FilesListFilesProps } from './Type'

const FilesMainKindDetails: React.FC<FilesListFilesProps> = ({ files }): React.ReactElement => {
  const classes = useStyles()
  return (
    <AccordionDetails className={classes.container}>
      {files.map((file) => (
        <FilesListFilesItem key={file.id} file={file} />
      ))}
    </AccordionDetails>
  )
}

export default FilesMainKindDetails
